import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import './CheckEmail.scss';
import Logo2 from '../../../components/Logo/Logo2';

const messages = {
    'email-verification': ['We just sent a verification link to', 'Please click the link to confirm your email.'],
    'reset-password': ['We have sent a password reset link to', 'Please click the link to reset your password.'], // Please check your email for instructions to reset your password.
}

const CheckEmail = () => {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();


    const queryParams = new URLSearchParams(location.search);

    const emailParam = queryParams.get('email');

    const typeParam = queryParams.get('type') || '';
    const type = Object.keys(messages).includes(typeParam) ? typeParam : 'email-verification';

    // const handleSignUpClick = (event) => {
    //     event.preventDefault();
    //     setTimeout(() => { history.push('/signup'); }, 100);
    // };

    useEffect(() => {
        document.title = t('pages.check_email.doc_title');
    }, [t, i18n.language]);

    return (
        <div className="check-email-box">
            <Logo2 />
            <div className='check-email'>
                <svg width="58px" height="60px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path fill="#494c4e"
                        d="M23.99 6.13V6c0-.18-.01-.35-.06-.53C23.69 4.6 22.9 4 22 4H2C1.1 4 .31 4.6.07 5.47.02 5.65 0 5.82 0 6v12c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2l-.01-11.87zm-2-.13L12 12 2 6h19.99zM2 18V8.33l8.97 5.38c.32.19.67.29 1.03.29s.71-.1 1.03-.29l8.96-5.38L22 18H2z"
                        style={{
                            strokeWidth: '0.7px',
                            stroke: 'rgb(8, 18, 20)',
                            fill: '#edf4ff',
                        }}
                    ></path>
                </svg>
                <div className="check-email-title">Check your email</div>

                <div className='check-email-text-wrap'>
                    <p className="check-email-text">{messages[type][0]}</p>
                    <p className="check-email-text"><span className='check-email-text-hide'>your email</span> <b>{emailParam}</b>.</p>
                    {/* <p className="check-email-text">{messages[type][1]}</p> */}
                </div>

                {/* <a href="" className="check-email-action">
                    <span>Resend Email</span>
                </a> */}
            </div>
        </div >
    );
};

export default CheckEmail;
